import React from 'react'

function Footer() {
  return (
    <div className='footer'>
      <b>Designed and Built by Charnaye Grier</b>
    </div>
  )
}

export default Footer